import './ScriptsDialog.css';
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { SketchPicker } from 'react-color';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import Icons from '../../../libraries/Icons';

function ScriptsDialog(props) {
    const { translate, open, data, handleClose, handleAgree, projects, handleOpenProjects} = props;
    const [isError, setIsError] = React.useState(false);
    const [scriptID, setScriptID] = React.useState();
    const [projectID, setProjectID] = React.useState();
    const [name, setName] = React.useState();
    const [icon, setIcon] = React.useState();
    const [color, setColor] = React.useState();
    const [displayColorPicker, setDisplayColorPicker] = React.useState(false);
    const [bgColor, setBgColor] = React.useState();
    const [displayBgColorPicker, setDisplayBgColorPicker] = React.useState(false);
    const [errorNotificationYN, setErrorNotificationYN] = React.useState();
    const [description, setDescription] = React.useState();
    const [duplicateFlg, setDuplicateFlg] = React.useState();

    const handleClickAgree = () => {
        setIsError(false);
        if(
            !projectID ||
            !name ||
            !icon ||
            !color ||
            !bgColor ||
            (errorNotificationYN === '' || errorNotificationYN === undefined)
        ) {
            setIsError(true);
            return;
        }
        handleAgree({
            scriptID,
            projectID,
            name,
            icon,
            color,
            bgColor,
            errorNotificationYN,
            description,
            duplicateFlg
        });
    }

    const handleClickColorPicker = (name) => {
        switch (name) {
            case "color":
                setDisplayColorPicker(!displayColorPicker)
                break;
            case "bgColor":
                setDisplayBgColorPicker(!displayBgColorPicker)
                break;
        }
    }

    const handleCloseColorPicker = (name) => {
        switch (name) {
            case "color":
                setDisplayColorPicker(false)
                break;
            case "bgColor":
                setDisplayBgColorPicker(false)
                break;
        }
    }

    const handleChangeColorPicker = (name, {hex}) => {
        switch (name) {
            case "color":
                setColor(hex)
                break;
            case "bgColor":
                setBgColor(hex)
                break;
        }
    }

    useEffect(() => {
        setIsError(false);
        setScriptID(data?.scriptID || undefined);
        setProjectID(data?.projectID);
        setName(data?.name);
        setIcon(data?.icon || 'fa-robot');
        setColor(data?.color || '#F2F5E9');
        setBgColor(data?.bgColor || '#6DC0F5');
        setErrorNotificationYN(parseInt(data?.errorNotificationYN) || 0);
        setDescription(data?.description);
        setDuplicateFlg(data?.duplicateFlg || false);
    }, [open])

    return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {duplicateFlg ? translate('duplicaterobot') : scriptID ? translate('updaterobot') : translate('addnewrobot')}
        </DialogTitle>
        <DialogContent dividers>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl fullWidth className='scripts-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('projectname')}</Typography>
                        <Box display="flex" gap={1}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                value={projects?.find(project => project.ID  === projectID) || null}
                                options={projects}
                                getOptionLabel={(option) => option?.name}
                                renderInput={
                                    (params) => <TextField placeholder={translate('selectyourprojectname')} error={!projectID && isError} {...params}/>
                                }
                                onChange={(event, newValue) => {
                                    setProjectID(newValue.ID);
                                }}
                            />
                            <IconButton color="primary" sx={{ width: "40px" }} onClick={handleOpenProjects}>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Box>
                        {(!projectID) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required className='scripts-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('robotname')}</Typography>
                        <OutlinedInput
                            id="robotName"
                            size='small' 
                            placeholder={translate('enteryourrobotname')}
                            value={name}
                            error={!name && isError}
                            onChange={(e) => setName(e.target.value)}
                        />
                        {!name && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={4}>
                    <FormControl fullWidth required className='scripts-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('icon')}</Typography>
                        <Select
                            id="icon"
                            size='small'
                            value={Icons?.find(ico => ico.key === icon)}
                            error={!icon && isError}
                            onChange={(e) => setIcon(e.target.value)}
                            renderValue={(selected) => (
                                <>
                                    <Box 
                                        component="i"
                                        className={"icon fa-solid" + ` ${selected.key}`}
                                        sx={{ position: "absolute" }}
                                    ></Box>
                                    <Box ml={4}>{selected.name}</Box>
                                </>
                            )}
                        >
                            {Icons.map((ico) => (
                                <MenuItem value={ico.key} key={ico.key}>
                                    <Box 
                                        component="i"
                                        className={"icon fa-solid" + ` ${ico.key}`}
                                    ></Box>
                                    <Box px={1}>{ico.name}</Box>
                                </MenuItem>
                            ))}
                            
                        </Select>
                        {!icon && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={4}>
                    <FormControl fullWidth required className='scripts-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('backgroundcolor')}</Typography>
                        <OutlinedInput
                            id="backgroundcolor"
                            size='small' 
                            placeholder=""
                            value={bgColor}
                            error={!bgColor && isError}
                            onChange={(e) => setBgColor(e.target.value)}
                        />
                        <div className='color-picker'>
                            <div className='swatch' onClick={() => handleClickColorPicker("bgColor")}>
                                <Box className='color' sx={{ backgroundColor: bgColor }} />
                            </div>
                            {displayBgColorPicker ? 
                            <div className='popover'>
                                <div className='cover' onClick={() => handleCloseColorPicker("bgColor") }/>
                                <SketchPicker color={bgColor} onChange={(value) => handleChangeColorPicker("bgColor", value)} />
                            </div> : 
                            null }
                        </div>
                        {!bgColor && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={4}>
                    <FormControl fullWidth required className='scripts-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('color')}</Typography>
                        <OutlinedInput
                            id="color"
                            size='small' 
                            placeholder=""
                            value={color}
                            error={!color && isError}
                            onChange={(e) => setColor(e.target.value)}
                        />
                        <div className='color-picker'>
                            <div className='swatch' onClick={() => handleClickColorPicker("color")}>
                                <Box className='color' sx={{ backgroundColor: color }} />
                            </div>
                            {displayColorPicker ? 
                            <div className='popover'>
                                <div className='cover' onClick={() => handleCloseColorPicker("color") }/>
                                <SketchPicker color={color} onChange={(value) => handleChangeColorPicker("color", value)} />
                            </div> : 
                            null }
                        </div>
                        {!color && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required className='scripts-dialog'>
                        <FormLabel>{translate('sendinganemailwhenanerroroccurs')}</FormLabel>
                        <RadioGroup
                            row
                            name="sendinganemailwhenanerroroccurs"
                            value={errorNotificationYN}
                            onChange={(e) => setErrorNotificationYN(parseInt(e.target.value))}
                        >
                            <FormControlLabel value={0} control={<Radio />} label={translate('no')} />
                            <FormControlLabel value={1} control={<Radio />} label={translate('yes')} />
                        </RadioGroup>
                        {(errorNotificationYN === '' || errorNotificationYN === undefined) && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required className='scripts-dialog'>
                        <Typography fontSize="inherit" component="label">{translate('description')}</Typography>
                        <OutlinedInput
                            id="description"
                            size='small' 
                            placeholder=""
                            value={description}
                            // error={!description && isError}
                            onChange={(e) => setDescription(e.target.value)}
                            multiline
                            rows={3}
                        />
                        {/* {!description && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        } */}
                    </FormControl>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" size="small" disableElevation color='secondary' onClick={handleClose}>
            {translate('cancel')}
            </Button>
            <Button variant="contained" size="small" disableElevation color="info" onClick={handleClickAgree}>
            {translate('ok')}
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default withTranslate(ScriptsDialog);